import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    NOTIFY_PROFILE_LIST,
    NOTIFY_PROFILE_SET,
    NOTIFY_PROFILE_REMOVE,
    RESPOND_DHCPD_CONFIG_GET,
    RESPOND_DHCPD_CONFIG_REMOVE,
    RESPOND_DHCPD_CONFIG_SET,
    RESPOND_NETWORK_NICS,
    RESPOND_NETWORK_STATICROUTE_CONFIG,
    NOTIFY_CONNECTION_ACTIVATE,
    RESPOND_DHCPD_CONFIG_EDIT,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/config/networkConfigMsgDefinitions";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import {
    DhcpdConfigList,
    DhcpdConfigServer,
    NetworkConnectionProfiles,
    NetworkInterfaces,
    NetworkStaticRoutes,
} from "userful-chronos-app-common-js/dist/models/config/networkConnections";
import configStore from "../networkConfigStore";
import { networkConnectionsSliceActions } from "../networkConnectionsSlice";
import {
    cleanNotSetValues,
    convertDhcpdConfigListToDhcpdConfigServer,
    convertInterfacesToDhcpdConfigServer,
    removeDhcpdConfigServer,
} from "./networkConfigLogic";

// Connections:
registerMsgHandler(NOTIFY_PROFILE_LIST, (payload) => {
    console.debug("receive NOTIFY_PROFILE_LIST");
    const data = JSON.parse(payload) as NetworkConnectionProfiles;

    configStore.dispatch(networkConnectionsSliceActions.setConnectionData(cleanNotSetValues(data.profiles)));
});
registerMsgHandler(NOTIFY_PROFILE_SET, (payload) => {
    console.debug("receive NOTIFY_PROFILE_SET");
    const data = JSON.parse(payload) as NetworkConnectionProfiles;

    configStore.dispatch(networkConnectionsSliceActions.setConnectionData(cleanNotSetValues(data.profiles)));
});
registerMsgHandler(NOTIFY_PROFILE_REMOVE, (payload) => {
    console.debug("receive NOTIFY_PROFILE_REMOVE");
    const data = JSON.parse(payload) as StringID;

    configStore.dispatch(networkConnectionsSliceActions.removeConnection(data));
});
registerMsgHandler(NOTIFY_CONNECTION_ACTIVATE, (payload) => {
    console.debug("receive NOTIFY_CONNECTION_ACTIVATE");
    const data = JSON.parse(payload) as NetworkConnectionProfiles;

    configStore.dispatch(networkConnectionsSliceActions.setConnectionData(cleanNotSetValues(data.profiles)));
});

// Static Routes:
registerMsgHandler(RESPOND_NETWORK_STATICROUTE_CONFIG, (payload) => {
    console.debug("receive RESPOND_NETWORK_STATICROUTE_CONFIG");
    const data = JSON.parse(payload) as NetworkStaticRoutes;

    configStore.dispatch(networkConnectionsSliceActions.updateRoutesConnection(data));
});

// DHCP Config:
registerMsgHandler(RESPOND_DHCPD_CONFIG_GET, (payload) => {
    console.debug("receive RESPOND_DHCPD_CONFIG_GET");
    const data = JSON.parse(payload) as DhcpdConfigList;

    const dhcp: DhcpdConfigServer[] = cleanNotSetValues(convertDhcpdConfigListToDhcpdConfigServer(data));

    configStore.dispatch(networkConnectionsSliceActions.setDHCPData(dhcp));
});
registerMsgHandler(RESPOND_DHCPD_CONFIG_SET, (payload) => {
    console.debug("receive RESPOND_DHCPD_CONFIG_SET");
    const data = JSON.parse(payload) as DhcpdConfigList;

    const dhcp: DhcpdConfigServer[] = cleanNotSetValues(convertDhcpdConfigListToDhcpdConfigServer(data));

    configStore.dispatch(networkConnectionsSliceActions.setDHCPData(dhcp));
});
registerMsgHandler(RESPOND_DHCPD_CONFIG_REMOVE, (payload) => {
    console.debug("receive RESPOND_DHCPD_CONFIG_REMOVE");
    const data = JSON.parse(payload) as StringID;

    const dhcp: DhcpdConfigServer[] = cleanNotSetValues(removeDhcpdConfigServer(data));

    configStore.dispatch(networkConnectionsSliceActions.setDHCPData(dhcp));
});
registerMsgHandler(RESPOND_DHCPD_CONFIG_EDIT, (payload) => {
    console.debug("receive RESPOND_DHCPD_CONFIG_EDIT");
    const data = JSON.parse(payload) as DhcpdConfigList;

    const dhcp: DhcpdConfigServer[] = cleanNotSetValues(convertDhcpdConfigListToDhcpdConfigServer(data));

    configStore.dispatch(networkConnectionsSliceActions.setDHCPData(dhcp));
});

// NIC Config:
registerMsgHandler(RESPOND_NETWORK_NICS, (payload) => {
    console.debug("receive RESPOND_NETWORK_NICS");
    const data = JSON.parse(payload) as NetworkInterfaces;

    const dhcp: DhcpdConfigServer[] = cleanNotSetValues(convertInterfacesToDhcpdConfigServer(data.interfaceIDs));

    configStore.dispatch(networkConnectionsSliceActions.setDHCPData(dhcp));
    configStore.dispatch(networkConnectionsSliceActions.setNetworkInterfaces(data.interfaceIDs));
});
